export default __webpack_public_path__ + "static/media/flash11.3eb014e5.png";